// extracted by mini-css-extract-plugin
export default {"modalContent":"ProductZoomModal_modalContent__bSxGl","info":"ProductZoomModal_info__oyX1z","flexRow":"ProductZoomModal_flexRow__cJ6M8","orderNow":"ProductZoomModal_orderNow__sMtQ8"};